import type { Object3D, Mesh } from 'three';
import type { WarpMesh } from './warpCulling';

/**
 * Collects all meshes with ams materials that need frustum culling toggled
 * during painter projection. Call once after world build, not per-frame.
 */
export function collectWarpMeshes(root: Object3D): WarpMesh[] {
  const meshes: WarpMesh[] = [];

  root.traverse((obj) => {
    if ('isMesh' in obj) {
      const mesh = obj as Mesh;
      const mat = mesh.material;
      if (mat && !Array.isArray(mat) && mat.userData?.ams) {
        meshes.push(mesh);
      }
    }
  });

  return meshes;
}
